import { Phone, MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "40745643348"; // international format without +
const WHATSAPP_MSG = encodeURIComponent("Bună ziua! Sunt interesat(ă) de o ofertă personalizată. Mulțumesc!");
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`;

export default function FloatingCall() {
    return (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 items-end">
            <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="floating-whatsapp-btn"
                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white px-5 py-3 shadow-lg shadow-[#0d3d2e]/30 hover:bg-[#1ebe57] transition-all hover:translate-y-[-1px]"
            >
                <MessageCircle className="h-4 w-4" strokeWidth={2} fill="white" />
                <span className="text-sm font-semibold">WhatsApp</span>
            </a>
            <a
                href="tel:0745643348"
                data-testid="floating-call-btn"
                className="lg:hidden inline-flex items-center gap-2 rounded-full bg-[#d4af37] text-[#1a1a1a] px-5 py-3 shadow-lg shadow-[#0d3d2e]/30 hover:bg-[#e0bd49] transition-colors"
            >
                <Phone className="h-4 w-4" strokeWidth={2} />
                <span className="text-sm font-semibold">Sună acum</span>
            </a>
        </div>
    );
}
